import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';

import { AttendanceService } from '../../attendance-record/attendance.service';

@Component({
  selector: 'app-status-table',
  templateUrl: './status-table.component.html',
  styleUrls: ['./status-table.component.css']
})
export class StatusTableComponent implements OnInit, OnChanges {
  @Input() staffs;

  isMobile: boolean;

  constructor(
    private attendanceService: AttendanceService
  ) { }

  ngOnInit() {
    this.isMobile = this.attendanceService.getIsMobile;
  }

  formatTime(date) {
    return moment(date).format('H:mm')
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(this.staffs);
  }

}
